<template>
    <div
        :class="{
            'form-group': withLabel,
            'has-error': error,
        }"
    >
        <slot name="label" :currency-prefix="currencyPrefix">
            <label
                :for="name"
                class="control-label"
                v-text="label"
            ></label>
        </slot>
        <money
            :id="inputId"
            v-model="amount"
            v-bind="money"
            class="form-control"
            v-bind:name="name"
        ></money>
        <div
            class="help-block"
            v-if="error"
            v-text="error"
        ></div>
    </div>
</template>

<script>

import {currencySymbol} from "../../../../mixins/currency";
import {Money} from 'v-money'

export default {
    name: `MoneyInput`,
    components: {
        Money
    },
    mixins: [currencySymbol],
    props: {
        error: {
            default: false,
            required: false,
            type: [Boolean, String],
        },
        label: {
            required: false,
            type: String,
        },
        name: {
            default: `money-input`,
            required: false,
            type: String,
        },
        withLabel: {
            default: true,
            required: false,
            type: Boolean,
        },
        currency: {
            default: "GBP",
            required: false,
            type: String,
        },
        initialAmount: {
            default: 0,
            required: false,
            type: Number
        },
        inputId: {
            default: 'money',
            required: false,
            type: String,
        },
    },

    data() {
        return {
            amount: 0,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: this.convertCurrencyCodeToPrefix(this.currency),
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },
    created() {
        this.amount = this.initialAmount;
    },
    computed: {
        currencyPrefix() {
            return this.convertCurrencyCodeToPrefix(this.currency);
        },
    },
    watch: {
        amount: function (newVal, oldVal) {
            this.$emit('input', newVal);
        },
        currencyPrefix: function (newVal, oldVal) {
            this.money.prefix = newVal;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/MoneyInput.vue